import { Controller } from '@hotwired/stimulus';

// 配布件数のHTML部品を取得して表示
export default class extends Controller {
  static values = {
    isCached: Boolean,
    distributionStatus: String,
    url: String,
  };

  connect() {
    if (this.isCachedValue || this.distributionStatusValue === 'completed')
      return;

    this.distributeButton = document.querySelector(
      '[data-shop-coupon-distribution-distribute-button]',
    );
    this.load();
  }

  load() {
    fetch(this.urlValue)
      .then((response) => response.json())
      .then((data) => {
        // 配布件数のHTML部品を更新
        this.element.innerHTML = data.distribution_count_html;
        // 配布可能な場合は配布ボタンを有効化
        if (data.distributable && this.distributeButton) {
          this.distributeButton.disabled = false;
        }
      })
      .catch(() => {
        this.element.textContent = '読込エラー';
      });
  }
}
